import React, { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
  Paper,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SearchHeader, { filterByKeyword } from "../common/components/SearchHeader";
import CollectionActions from "../common/components/CollectionActions";
import CollectionFab from "../settings/CollectionFab";
import TableShimmer from "../common/components/TableShimmer";
import ErrorDialog from "../common/components/ErrorDialog";
import { getWithExpiry } from "../common/util/localstorage";
import { usersActions } from "../store";

const UsersPage = () => {
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [opening, setOpening] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Erreur !!");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const users = useSelector((state) => state.users.items);
  const currentUser = useSelector((state) => state.session.user);

  const handleDialogClose = () => setOpening(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${process.env.REACT_APP_URL_NAME}/users`, {
          headers: {
            Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
          },
        });
        if (!res.ok) {
          if (res.status === 401) {
            setErrorMsg("UNAUTHORIZED");
            setOpening(true);
            navigate("/login");
          } else {
            const text = await res.text();
            setErrorMsg(text);
            setOpening(true);
            throw new Error(text);
          }
        } else {
          const data = await res.json();
          dispatch(usersActions.setItems(data));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [dispatch, navigate]);

  return (
    <Paper sx={{ p: 2 }}>
<Typography
  variant="h3"
  align="center"
  sx={{
    mb: { xs: 2, sm: 3 },
    fontWeight: 800,
    background: "linear-gradient(90deg, #002355, #0081f9)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
    textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
  }}
>        Users
      </Typography>

      <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />

      <Table>
        <TableHead >
         <TableRow
    sx={{
      backgroundColor: "#002355",
      color: "#fff",
      "& th": {
        color: "#fff",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: { xs: 12, sm: 14 },
        borderBottom: "none",
      },
      "& th.actions": {
        color: "#0081f9",
      },
    }}
  >     
            <TableCell>Username</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading && users && users.length > 0 ? (
            users
              .filter(filterByKeyword(searchKeyword, ["username", "email", "role"]))
              .map((user) => (
                <TableRow key={user._id}>
                  <TableCell>{user.username}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell padding="none">
                    <CollectionActions
                      itemId={user._id}
                      editPath="/settings/user"
                      endpoint="users"
                      action={usersActions}
                      removable={user.role !== "superadmin"} // cannot remove superadmin
                    />
                  </TableCell>
                </TableRow>
              ))
          ) : (
            <TableShimmer columns={4} endAction />
          )}
        </TableBody>
      </Table>

      <CollectionFab editPath="/settings/user" />

      <ErrorDialog
        open={opening}
        errorMsg={errorMsg}
        onResult={handleDialogClose}
      />
    </Paper>
  );
};

export default UsersPage;
